/** iter 42 — Mobile / Routes list. */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../lib/api";
import MobileShell from "../MobileShell";

export default function MRoutes() {
  const navigate = useNavigate();
  const [items, setItems] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    api.get("/mobile/my-routes")
      .then(r => setItems(r.data || []))
      .catch(e => setErr(e?.response?.data?.detail || e.message));
  }, []);

  return (
    <MobileShell title="My Routes">
      {err && <div className="m-empty">{String(err)}</div>}
      {!err && items === null && <div className="m-empty">Loading…</div>}
      {!err && items?.length === 0 && (
        <div className="m-empty" data-testid="m-routes-empty">No routes scheduled.</div>
      )}
      {items?.map(r => (
        <button
          key={r.id}
          type="button"
          className="m-card"
          style={{ width: "100%", textAlign: "left", cursor: "pointer" }}
          onClick={() => navigate(`/m/routes/${r.id}`)}
          data-testid={`m-route-row-${r.id}`}
        >
          <div className="m-card-title">{r.name || "Untitled route"}</div>
          <div className="m-card-sub">
            {r.scheduled_date || "—"} · {r.stop_count || 0} stop{r.stop_count === 1 ? "" : "s"}
          </div>
          {r.notes && <div className="m-card-sub" style={{ marginTop: 4 }}>{r.notes}</div>}
        </button>
      ))}
    </MobileShell>
  );
}
